import React from 'react';
import styled from 'styled-components';
import sharedStyles from '@repo/ui-components/styles';
import SupportArticleText from './SupportArticleText';

const DecisionTreeContainer = styled.div``;

const DecisionItem = styled.div`
  display: flex;
  padding-top: ${sharedStyles.spacing['spacing-sm']};
  padding-bottom: ${sharedStyles.spacing['spacing-sm']};
  border-top: 1px solid ${({ theme }) => theme.colors.brandPrimary};
`;

const DecisionTextWrapper = styled.div`
  flex: 2;
  border-right: 1px solid ${({ theme }) => theme.colors.brandPrimary};
`;

const DecisionTextAnswer = styled.div`
  flex: 1;

  > p {
    padding-left: ${sharedStyles.spacing['spacing-sm']};
    margin: 0;
  }
`;

const StepIcon = styled.i`
  height: 2rem;
  color: ${({ theme }) => theme.colors.brandPrimary};
  font-size: 1.875em;
  margin-right: 0.5rem;
`;

const StepIconWrapper = styled.div``;

function SupportArticleDecisionTree({ section }) {
  return (
    <DecisionTreeContainer>
      {section?.decisionSteps?.map(item => {
        return (
          <DecisionItem key={`${section._key}`}>
            {item?.icon && (
              <StepIconWrapper>
                <StepIcon className={item?.icon} />
              </StepIconWrapper>
            )}
            <DecisionTextWrapper>
              <SupportArticleText text={item?.question?.text} />
            </DecisionTextWrapper>
            <DecisionTextAnswer>
              <SupportArticleText text={item?.yesAction?.text} />
              <SupportArticleText text={item?.noAction?.text} />
            </DecisionTextAnswer>
          </DecisionItem>
        );
      })}
    </DecisionTreeContainer>
  );
}

export default SupportArticleDecisionTree;
